import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label, 
    Modal, ModalHeader, ModalBody, Table
} from "reactstrap"
import { accessRole } from '../../../../helpers/access_role'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm,  AvField, } from "availity-reactstrap-validation"

import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import { cancelToken } from "../../../../services/adapters/kepegawaian/diklatService"
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import YearSelect from '../../GlobalComponents/YearSelect'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

import CreateBloc from './Blocs/CreateBloc'
import IndexBloc from '../Index/Blocs/DiklatBloc'

class IndexView extends Component {

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_nip = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_nip : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_nip : "")
    peg_position = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_current_position_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_current_position_uuid : "")

    source
    indexBloc = new IndexBloc()
    createBloc = new CreateBloc()

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            trainingOption: [],
            regionOption: [],
            provinceOption: [],
            cityOption: [],
            trainingFilter: {
                            filter_value: "",
                            page_number: 1,
                            page_size: 50,
                            sort_order: {
                                column: 'training_type_sort',
                                order: 'asc' 
                            }
                        },
            isSearch: false,
            hoursDetail: {},
            domicile: 0,
            modal: false 
        }
    }
    
    toggleModal = () => {
        this.setState({ modal: !this.state.modal })
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              training_employee_position_uuid: this.peg_position,
              employee_nip: this.peg_nip,
              training_employee_uuid: this.peg_uuid,
              training_type: this.props.type,
              ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'file') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    getCity = (province_uuid) => {
        this.indexBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ cityOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })
        const query = { 
            is_local: 1,
            type : 3,
            parent_uuid : province_uuid
        }
        this.indexBloc.fetchRegionCity(query, this.source.token)
    }

    loadProvince = async () => {
        const query = { 
            parent_uuid: '61b47307-167d-489f-bb6c-c1c9662acab3',
            type: 2
        }
        await this.indexBloc.fetchRegionProvince(query, this.source.token)
    }

    loadRegion = async () => {
        const query = { type: 1 }
        await this.indexBloc.fetchRegion(query, this.source.token)
    }

    loadHours = async () => {
        const query = {
            employee_uuid: this.peg_uuid
        }
        await this.indexBloc.fetchHours(query, this.source.token)
    }

    loadTraining = async () => {
        let offset = (this.state.trainingFilter.page_number-1)*this.state.trainingFilter.page_size
        const query = {
            type: this.props.type,
            search: this.state.trainingFilter.filter_value,
            limit: this.state.trainingFilter.page_size,
            offset: offset,
            order: this.state.trainingFilter.sort_order.column,
            sort: this.state.trainingFilter.sort_order.order,
            status: 1,
            jenis : this.props.type == "Struktural" ? 1 : this.props.type == "Fungsional" ? 2 : 3
        }
        await this.createBloc.fetchTrainingList(query, this.source.token)
    }



    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadTraining()
        this.loadHours()
        this.loadRegion()
        this.loadProvince()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.createBloc.trainingListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        trainingOption: result.data.response.result
                    })
                    break;
            
                default:
                    break;
            }
        })

        this.indexBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ provinceOption: result.data.response.result })
                    break;
                default:
                    break;
            }
            console.log('cek result', result.data.response)
        })

        this.indexBloc.regionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ regionOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.hoursChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        hoursDetail: result.data.response
                    })
                    break;
                default:
                    break;
            }
        })

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.trainingListChannel?.unsubscribe()
        this.indexBloc.hoursChannel?.unsubscribe()
        this.indexBloc.regionChannel?.unsubscribe()
        this.indexBloc.regionCityChannel?.unsubscribe()
        this.indexBloc.regionProvinceChannel?.unsubscribe()
    }

    render() {
        const { type } = this.props
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <PegawaiSideBar active={`diklat&type=${type}`} />

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Tambah Diklat {type}</CardTitle>    
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="diklatName"
                                                className="col-md-2 col-form-label"
                                            >
                                                Nama Diklat <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="training_training_type_uuid"
                                                    errorMessage="Pilih Diklat"
                                                    options={this.state.trainingOption} 
                                                    placeholder="Pilih Diklat"
                                                    optionLabel="training_type_name"
                                                    optionValue="training_type_uuid"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <hr/>
                                        <Label># Tempat Diklat</Label>
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">Dalam / Luar Negeri<span className="text-danger">*</span></Label>
                                             <Col md="3">
                                                <CustomSelect 
                                                    name="training_domicile"
                                                    errorMessage="Pilih Domisili"
                                                    options={[{ value: 0, label: 'Dalam Negeri' }, { value: 1, label: 'Luar Negeri' }]}
                                                    defaultValue={this.state.domicile}
                                                    onChange={opt => this.setState({ domicile: opt.value })}
                                                    placeholder="Pilih Domisili"
                                                    validate={{ required: { value: true } }}
                                                    isSearchable={false}
                                                />
                                            </Col>                                           
                                        </Row>
                                        { this.state.domicile == 0 ?
                                            <Fragment>
                                                <AvField 
                                                    type="hidden" 
                                                    name="training_country_uuid" 
                                                    value={this.state.regionOption?.filter(value => value.region_name == 'Indonesia')[0]?.region_uuid} 
                                                />
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Provinsi <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="training_province_uuid"
                                                            errorMessage="Pilih Provinsi"
                                                            // onChange={this.handleIdentitySelectProvince}
                                                            onChange={value => this.getCity(value.region_uuid)}
                                                            options={this.state.provinceOption}
                                                            optionLabel="region_name"
                                                            optionValue="region_uuid" 
                                                            validate={{ required: { value: true } }}
                                                            placeholder="Pilih Provinsi"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="training_city_uuid"
                                                            errorMessage="Pilih Kota"
                                                            options={this.state.cityOption} 
                                                            optionLabel="region_name"
                                                            optionValue="region_uuid"
                                                            validate={{ required: { value: true } }}
                                                            placeholder="Pilih Kota"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">Negara <span className="text-danger">*</span></Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="training_country_uuid"
                                                            errorMessage="Pilih Negara"
                                                            options={this.state.regionOption}
                                                            optionValue="region_uuid"
                                                            optionLabel="region_name"
                                                            placeholder="Pilih Negara"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>                                           
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <AvField
                                                            name="training_city_text"
                                                            placeholder="Kota..."
                                                            type="text"
                                                            errorMessage="Masukkan Kota"
                                                            className="form-control"
                                                            validate={{ required: { value: this.state.isLocal == 1 ? false : true } }}
                                                            id="place_of_birth_city_text"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        }
                                        <hr/>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldPenyelenggara"
                                                className="col-md-2 col-form-label"
                                            >
                                                Penyelenggara <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="training_organizer"
                                                    placeholder="Penyelenggara..."
                                                    errorMessage="Masukkan Nama Penyelenggara"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldPenyelenggara"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldAngkatan"
                                                className="col-md-2 col-form-label"
                                            >
                                                Angkatan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="training_generation"
                                                    placeholder="Angkatan..."
                                                    errorMessage="Masukkan Nama Angkatan"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldAngkatan"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTahun"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tahun <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="2">
                                                <YearSelect 
                                                    name="training_year"
                                                    errorMessage="Masukkan Tahun"
                                                    placeholder="Tahun..."
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglMulai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="training_start_date"
                                                    placeholder="Tanggal Mulai..."
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglMulai"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglSelesai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="training_end_date"
                                                    placeholder="Tanggal Selesai..."
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglSelesai"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldSTTP"
                                                className="col-md-2 col-form-label"
                                            >
                                                No STTP <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="5">
                                                <AvField
                                                    name="training_sttpp_number"
                                                    placeholder="No STTP..."
                                                    errorMessage="Masukkan No STTP"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldSTTP"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglSTTP"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal STTP <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="training_sttpp_date"
                                                    placeholder="Tanggal STTP..."
                                                    errorMessage="Masukkan Tanggal STTP"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglSTTP"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Label
                                                htmlFor="fieldJmlJam"
                                                className="col-md-2 col-form-label"
                                            >
                                                Jumlah Jam <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="training_number_of_hours"
                                                    placeholder="Jumlah Jam..."
                                                    errorMessage="Masukkan Jumlah Jam"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldJmlJam"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            {this.state.hoursDetail &&
                                                <>
                                                    <Label className="col-md-2 col-form-label"></Label>
                                                    <Label className="col-md-6 col-form-label">
                                                        <span className="text-danger" style={{ fontSize: '12px' }} >Note: Jumlah jam diklat anda tahun ini telah mencapai {this.state.hoursDetail?.total_hours} jam. <a href="javascript:void(0)" onClick={() => this.toggleModal() }>Lihat Detail</a></span>
                                                    </Label>
                                                </>
                                            }
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldJmlJam"
                                                className="col-md-2 col-form-label"
                                            >
                                                File Pendukung
                                            </Label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="file"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`/kepegawaian/home.html?diklat&type=${type}`}>
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>    
                            </Card>    
                        </Col>
                    </Row> 
                </Container> 

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/home.html?diklat&type=${type}`} />
                : null }
                <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="lg">
                    <ModalHeader toggle={() => this.toggleModal()}>Keterangan Jam Diklat</ModalHeader>
                    <ModalBody>
                        <Table>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Diklat</th>
                                    <th>Jam Diklat</th>
                                </tr>
                            </thead>
                            <tbody>
                                { this.state.hoursDetail.diklat?.map((value, index) => {
                                    return (
                                        <Fragment>
                                            <tr>
                                                <th>{index + 1}</th>
                                                {/* <th>{value.training_type.training_type_name}, {value.training_type.training_type_description}</th> */}
                                                <th>{value.training_type_name}, {value.training_type_description}</th>
                                                <th>{value.training_number_of_hours}</th>
                                            </tr>
                                        </Fragment>
                                    )
                                }) }
                            </tbody>
                        </Table>
                    </ModalBody>
                </Modal>
            </Fragment>
        )
    }
}

export default IndexView
